// extracted by mini-css-extract-plugin
export var askAiIcon = "_pq-9";
export var container = "_pq-0";
export var groupSeparator = "_pq-a";
export var highlight = "_pq-4";
export var resultIcon = "_pq-5";
export var resultItem = "_pq-7";
export var resultSubtitle = "_pq-3";
export var resultTitle = "_pq-2";
export var resultsList = "_pq-1";
export var searchGroup = "_pq-6";
export var selected = "_pq-8";